import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { downloadedFile } from 'src/app/services/base/base.service';
import { FileStorageService } from 'src/app/services/file-storage/file-storage.service';
import { ManutencaoCTEService } from 'src/app/services/gestao-de-cte/gestao-de-cte.service';
import { preLoteDetails, sessaoCardGestaoPreLotes } from '../gestao-de-cte.model';
import { ModalPesoComponent } from '../components/modal-peso/modal-peso.component';
import { CTeHubService } from 'src/app/services/signalR/cte-hub/cte-hub.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ClienteOutput } from 'src/app/@shared/models/cliente.model';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClienteService } from 'src/app/services/cliente/cliente.service';

@Component({
  selector: "app-lotes",
  templateUrl: "./lotes.component.html",
  styleUrls: ["./lotes.component.scss"],
})
export class LotesComponent implements OnInit, OnDestroy {
  @Input() id: string; //identificador do pré-lote
  file: any;
  filtros: sessaoCardGestaoPreLotes[];
  preLoteDetails: preLoteDetails;

  validacaoStartSubscription: any;
  validacaoEndSubscription: any;

  public fileName: "";
  public fileType: "";
  allSelected = false;
  someSelected = false;
  isLoading: boolean = false;
  isLoadingDownload: boolean = false;
  declaracaoId: string;
  private onDestroy = new Subject<void>();

  identificador;
  bGeral: boolean = false;

  public ocultaBotoesDeclaracao: boolean = false;
  public fase: string;

  clientes: ClienteOutput[];
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<ClienteOutput[]>(1);
  public clienteMultiFilter: FormControl = new FormControl();

  public grid: MatTableDataSource<any> = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  public displayedColumns: any[] = [
    "action",
    "filial",
    "nrCTE",
    "chaveCTE",
    "dtEmissao",
    "qtdeNRT",
    "qtdeNF",
    "cliente",
    "tomador",
    "pid",
    "cepDestino",
    "peso",
    "tipoCte",
    "tipoProcessamento",
    "statusCancelamento",
    "statusCte",
    "statusLote",
    "valorFrete",
    "adValorem",
    "gris",
    "imposto",
    "totalFrete",
    // CTE Ação
    "numeroCTEAcao",
    "chaveCteAcao",
    "statusCteAcao",
    "reemissao",
    // CTE Recalculado
    "numeroCTERemissao",
    "chaveCteRemissao",
    "statusCteRemissao",
    "statusBloqueio",
  ];

  paging = { index: 0, size: 10, length: 0 };
  isLoadingUpload: boolean = false;
  itensIds: any = [];
  rowData: any;
  bSobrepor: boolean = false;

  // isConfirmacao: boolean = false;

  get obterCompletos() {
    var completos = this.filtros
      ?.map((f) => f.cards)
      .flat()
      .filter((c) => c.id == 1)[0];
    return completos;
  }

  public filter: FormGroup = new FormGroup({});

  public filterForm = new FormGroup({
    clienteId: new FormControl(''),
    numeroCte: new FormControl(''),
    chaveCte: new FormControl(''),
    codBarras: new FormControl('')
  });
  get clienteId() { return this.filterForm.get('clienteId').value; }
  get numeroCte() { return this.filterForm.get('numeroCte').value; }
  get chaveCte() { return this.filterForm.get('chaveCte').value; }
  get codBarras() { return this.filterForm.get('codBarras').value; }

  constructor(
    public snackBar: MatSnackBar,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public service: ManutencaoCTEService,
    public fileService: FileStorageService,
    private clienteService: ClienteService,
    public cteHub: CTeHubService
  ) {
    const identificador = this.route.snapshot.paramMap.get("identificador");
    if (identificador) this.id = identificador;
    this.identificador = identificador;
    console.log('identificador', identificador);
  }

  ngOnInit() {
    this.loadLote();
    this.listarClientes();

    //conectar ao hub signalR
    this.cteHub.startConnection(() => {
      this.cteHub.conectar(this.identificador);
      this.validacaoStartSubscription =
        this.cteHub.prelotes_validacaoStart.subscribe((data) => {
          this.snackBar.open(`Iniciando validação do lote.`, "OK", {
            horizontalPosition: "right",
            verticalPosition: "top",
          });

          this.onReceiveUpdates(data);
        });
      this.validacaoEndSubscription =
        this.cteHub.prelotes_validacaoEnd.subscribe((data) => {
          this.snackBar.open(`Validação concluída!`, "OK", {
            horizontalPosition: "right",
            verticalPosition: "top",
          });

          this.onReceiveUpdates(data);
        });
    });
  }

  ngOnDestroy() {
    this.validacaoStartSubscription.unsubscribe();
    this.validacaoEndSubscription.unsubscribe();
  }

  //Será disparada a cada atualização de eventos de processamento
  onReceiveUpdates(prelote: preLoteDetails) {
    this.preLoteDetails = prelote;
    console.log(prelote);
    this.loadFilters();
  }

  clearFields() {
    this.filterForm.reset();
    this.loadFilters();
  }

  public async listarClientes() {
    return this.clienteService.list().toPromise().then((response: ClienteOutput[]) => {
      this.clientes = response.filter(x => x.nome != '').sort((a, b) => (a.nome < b.nome ? -1 : 1));
      this.filteredClientes.next(this.clientes.slice());
      this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.filteredClientes, 'nome');
        });
    },
      (err: HttpErrorResponse) => {
        this.openSnackBar('Erro ao carregar clientes, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  downloadDeclaracao(grid) {
    this.DownloadDocumentoGestao(grid.declaracaoId);
  }

  loadLote() {
    this.isLoading = true;
    this.service.obterLoteDetails(this.id).subscribe(
      (response: preLoteDetails) => {
        console.log('💬 ~ response loteDetails', response);

        if (response) {

          this.preLoteDetails = response;
          this.loadFilters();

        } else {
          this.openSnackBar(
            `Pré-lote inexistente.`,
            "OK",
            5000,
            "danger-snackbar"
          );
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          `Erro ao carregar informações de filtros, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  public loadGrid() {
    this.isLoading = true;
    const obj = {
      filtros: this.filtros
        .map((filtro) =>
          filtro.cards
            .filter((t) => t.selecionado === true)
            .map((t) => t.id)
        )
        .flat(),
      numeroCTE: this.numeroCte,
      chaveCTE: this.chaveCte,
      codBarras: this.codBarras,
      clienteID: this.clienteId,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };

    this.service
      .filtrarGridLotes(this.identificador, obj)
      .subscribe(
        (response: any[]) => {
          this.grid.data = response;
          response.length
            ? (this.paging.length = response[0].totalCount)
            : null;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao carregar informações de ${this.preLoteDetails.tipoAcaoDescricao}, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  public arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele != value;
    });
  }

  setRowData(grid) {
    this.rowData = grid;
  }

  setSobrepor(p: boolean) {
    this.bSobrepor = p;
  }

  public refreshFilter(event, card) {
    if (event.checked == true) {
      card.selecionado = true;
    } else {
      card.selecionado = false;
    }
    this.loadGrid();
  }

  public loadFilters() {
    this.isLoading = true;
    const obj = {
      identificador: this.id,
      confirmacao: false,
    };
    this.service
      .obterLoteCards(obj)
      .subscribe(
        (response: any[]) => {
          this.updateFilters(response);
          this.loadGrid();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(
            `Erro ao carregar informações de filtros, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      )
      .add(() => (this.isLoading = false));
  }

  updateFilters(tipoParams) {
    this.filtros = tipoParams;
    this.filter = new FormGroup({});
    tipoParams.forEach((element) => {
      element.cards.forEach((card) => {
        const control = new FormControl("");
        this.filter.addControl("filter_" + card.id, control);
      });
    });
  }

  public DownloadDocumentoGestao(identificador) {
    this.isLoadingDownload = true;
    this.fileService
      .DownloadFile(
        identificador,
        (response) => this.gerarArquivo(response),
        (err) => console.log(err)
      )
      .add(() => (this.isLoadingDownload = false));
  }

  private gerarArquivo(file: downloadedFile) {
    const url = window.URL.createObjectURL(file.blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel() {
    this.isLoadingDownload = true;
    const obj = {
      filtros: this.filtros
        .map((filtro) =>
          filtro.cards
            .filter((t) => t.selecionado === true)
            .map((t) => t.id)
        )
        .flat(),
      numeroCTE: this.numeroCte,
      chaveCTE: this.chaveCte,
      codBarras: this.codBarras,
      clienteID: this.clienteId,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size,
    };
    return this.service.exportarGridLotes(this.identificador, obj).subscribe(
      (response: any) => {
        this.gerarArquivo2(
          response.retorno.fileContents,
          response.retorno.fileDownloadName,
          response.retorno.contentType
        )
      },
      (err: HttpErrorResponse) => console.error('erro', err),
      () => this.isLoadingDownload = false
    )
  };

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo2(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data)
    const blob = new Blob([arrBuffer], {
      type
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  onPageChange(evt: { pageIndex: number; pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.loadGrid();
  }

  visualizarPeso(grid) {
    const dialogRef = this.dialog.open(ModalPesoComponent, {
      width: "1200px",
      data: { dados: grid, isModal: true },
    });
    dialogRef.afterClosed();
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
